<template>
  <v-dialog v-model="mostrar" max-width="500" persistent>
    <v-card>
      <v-toolbar color="primary" dark dense flat><h3>Modificar usuario</h3></v-toolbar>
      <v-container>
        <v-row>
          <v-col cols="8">
            <v-text-field
              v-model="codigo"
              label="Código"
              readonly
              color="blue-grey"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-select
              v-model="genero"
              label="Género"
              :disabled="loading"
              outlined
              dense
              :items="generos"
            ></v-select>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              v-model="nombre"
              label="Nombre"
              readonly
              color="blue-grey"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="correo"
              label="Correo"
              :loading="loading"
              color="blue-grey"
              outlined
              dense
              :error-messages="correoErrors"
              @input="validarCorreo()"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="4">
            <v-text-field
              v-model="telefono"
              label="Teléfono"
              type="number"
              :loading="loading"
              color="blue-grey"
              outlined
              dense
              min="0"
              counter="10"
              :error-messages="telefonoErrors"
              @input="validarTelefono()"
            ></v-text-field>
          </v-col>
          <v-col cols="8">
            <v-text-field
              v-model="domicilio"
              label="Domicilio"
              :loading="loading"
              color="blue-grey"
              outlined
              dense
              :error-messages="domicilioErrors"
              @input="validarDomicilio()"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <v-divider class="mx-3"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small outlined @click="$emit('cancelar')"
          >Cancelar</v-btn
        >
        <v-btn
          color="primary"
          small
          :class="{ 'disable-events': blockAceptar }"
          @click="modificarUsuario()"
          >Modificar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { minLength, maxLength, email } from 'vuelidate/lib/validators';
import { modificarUsuarioService } from './usuarios.service';

export default {
  name: 'modificarUsuario',
  props: ['mostrar', 'usuario'],
  mixins: [validationMixin],
  computed: {
    blockAceptar() {
      if (this.loading ) return true;
      if (this.telefonoErrors.length > 0 || this.domicilioErrors.length > 0) return true;
      return false;
    },
  },
  validations: {
    telefono: { minLength: minLength(10), maxLength: maxLength(10) },
    correo: { email },
    domicilio: { minLength: minLength(5) },
  },
  data() {
    return {
      loading: false,
      generos: [{ text: 'Mujer',value: 'M' },{ text: 'Hombre',value: 'H' }],
      codigo: '',
      nombre: '',
      genero: '',
      correo: '',
      telefono: '',
      domicilio: '',
      correoErrors: [],
      telefonoErrors: [],
      domicilioErrors: [],
    }
  },
  created() {
    this.codigo = this.usuario.codigo;
    this.nombre = this.usuario.nombre;
    this.genero = this.usuario.genero;
    this.correo = this.usuario.correo;
    this.telefono = this.usuario.telefono.celular;
    this.domicilio = this.usuario.domicilio;
  },
  methods: {
    validarCorreo() {
      this.$v.usuario.correo.$touch();
      this.correoErrors = [];
      if (this.$v.usuario.correo.$dirty) {
        !this.$v.usuario.correo.email && this.correoErrors.push('Correo no válido.');
      }
    },
    validarTelefono() {
      this.$v.telefono.$touch();
      this.telefonoErrors = [];
      if (this.$v.telefono.$dirty) {
        !this.$v.telefono.minLength && this.telefonoErrors.push('Mínimo 10 dígitos.');
        !this.$v.telefono.maxLength && this.telefonoErrors.push('Máximo 10 dígitos.');
        this.telefono < 0 && this.telefonoErrors.push('Número no debe ser negativo.');
        !/^\d*$/.test(this.telefono) && this.telefonoErrors.push('Número no válido.');
        !Number.isInteger(Number(this.telefono)) && this.telefonoErrors.push('Número no debe tener decimales.');
      }
    },
    validarDomicilio() {
      this.$v.usuario.domicilio.$touch();
      this.domicilioErrors = [];
      if (this.$v.usuario.domicilio.$dirty) {
        !this.$v.usuario.domicilio.minLength && this.domicilioErrors.push('Mínimo 5 caracteres.');
      }
    },
    async modificarUsuario() {
      try {
        this.loading = true;
        this.usuario.telefono.celular = this.telefono;
        const sendData = {
          idUsuario: this.usuario.idUsuario,
          correo: this.correo,
          genero: this.genero,
          telefono: {
            celular: this.telefono
          },
          domicilio: this.domicilio
        };
        const serverResponse = await modificarUsuarioService(sendData);
        this.loading = false;
        if (!serverResponse.ok) {
          throw new Error(serverResponse.mensaje);
        }
        this.$emit("usuarioModificado", serverResponse.usuario);
      } catch (error) {
        this.loading = false;
        this.$notificarError(error);
      }
    },
  }
}

</script>